import React from 'react';
import Info from '../components/Info';

const Contact = () => {
    return (
        <div style={{ paddingTop: '80px' }}>
            <Info />
        </div>
    );
};

export default Contact;
